const React = require('react');
const _ = require('lodash');
const { DEFAULT_LOCALE } = require('../../lib/constants');

const glob = Function('return this')();

let createContext = _.noop;

if (typeof React.createContext === 'function') {
    createContext = React.createContext;
}

glob.FiverrContext = glob.FiverrContext || createContext({
    locale: DEFAULT_LOCALE
});

module.exports = glob.FiverrContext;
